import api from './interceptor';

const BASE_URL_V1 = 'api/v1/appointments';
const BASE_URL_V2 = 'api/v2/appointments';

export default {
  // API Version 1
  getAppointment: appointmentId => api.get(`${BASE_URL_V1}/${appointmentId}`),
  getAppointments: params => api.get(BASE_URL_V1, { params }),
  createAppointment: appointment => api.post(BASE_URL_V1, appointment),
  deleteAppointment: appointmentId => api.delete(`${BASE_URL_V1}/${appointmentId}`),
  purchaseWithCard: ({ appointmentId, payment, acceptGMDisclaimer }) => api.post(`${BASE_URL_V1}/${appointmentId}/payments`, { ...payment, acceptGMDisclaimer }),
  applyDiscount: (appointmentId, params) => api.post(`${BASE_URL_V1}/${appointmentId}/discount`, params),
  joinVideoRoom: (appointmentId, params) => api.put(`${BASE_URL_V1}/${appointmentId}/joinVideoRoom`, params),
  joinWaitingRoom: (appointmentId, params) => api.put(`${BASE_URL_V1}/${appointmentId}/joinWaitingRoom`, params),
  updateStatus: (appointmentId, status, params) => api.put(`${BASE_URL_V1}/${appointmentId}/${status}`, params),
  getScheduleAvailableDates: (params) => api.get(`${BASE_URL_V1}/timeslots-by-month`, { params }),
  getStatusesByMonth: (params) => api.get(`${BASE_URL_V1}/statuses-by-month/`, { params }),
  updateAppointment: (appointmentId, params) => api.put(`${BASE_URL_V1}/${appointmentId}`, params),
  addAdminNote: (appointmentId, params) => api.post(`${BASE_URL_V1}/note/${appointmentId}`, params),
  getAdminNotes: (appointmentId) => api.get(`${BASE_URL_V1}/notes/${appointmentId}`),
  getActiveStatuses: (params) => api.get(`${BASE_URL_V1}/active-statuses`, { params }),
  getMediasoupAvailable: (appointmentId, roomId, isInvitee) => api.get(`${BASE_URL_V1}/${appointmentId}/rooms/${roomId}/media-soup`, {
    headers: {
      Authorization: isInvitee ? `Bearer ${sessionStorage.getItem('token')}` : `Bearer ${localStorage.getItem('token')}`,
    },
  }),

  // API Version 2
  applyInsuranse: (appointmentId, params) => api.post(`${BASE_URL_V2}/${appointmentId}/insurance`, params),
  rescheduleAppointmentByPatient: ({ appointmentId, params }) => api.post(`${BASE_URL_V2}/${appointmentId}/reschedule`, params),
  rescheduleAppointmentByClinicAdmin: (appointmentId, params) => api.put(`${BASE_URL_V2}/${appointmentId}`, params),
  postAddendum: (appointmentId, params) => api.post(`${BASE_URL_V2}/${appointmentId}/soap-note/addendum`, params),
  getMedicalCertificate: appointmentId => api.get(`${BASE_URL_V2}/${appointmentId}/medical-certificate`),
  postMedicalCertificate: (appointmentId, params) => api.post(`${BASE_URL_V2}/${appointmentId}/medical-certificate`, params),
  updateMedicalCertificate: (appointmentId, params) => api.put(`${BASE_URL_V2}/${appointmentId}/medical-certificate`, params),
  sendSaveMedicalCertificate: (appointmentId, type) => api({
    url: `${BASE_URL_V2}/${appointmentId}/medical-certificate/${type}`,
    method: type === 'pdf' ? 'GET' : 'POST',
    responseType: type === 'pdf' ? 'blob' : 'json',
  }),
  sendOrderForm: (appointmentId, params, country) => api.post(`${BASE_URL_V2}/order-form/${appointmentId}?country=${country}`, params,
    {
      responseType: !params.sendToDischargedSummary ? 'blob' : 'json',
    }),
  pdfSoapNote: (appointmentId, soapNoteId) => api.get(`${BASE_URL_V2}/${appointmentId}/soap-note/${soapNoteId}/pdf`, { responseType: 'blob' }),
  shuffleAppointment: (appointmentId, shuffleAppointmentId) => api.post(`${BASE_URL_V2}/${appointmentId}/shuffle/${shuffleAppointmentId}`),
};
